'use strict';

var style = require('./style');

module.exports = style({
  prop: 'letterSpacing',
  key: 'letterSpacings',
  numberToPx: true
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/styled-system/dist/letter-spacing.js
// module id = 1362
// module chunks = 0